/**
* @name: AppRouterLayout
* @author: weiyong
* @date: 2022-10-02 21:00
* @description：frameHeader
* @update: 2022-10-02 21:00
*/
<template>
  <Layout :class="prefixCls"  v-bind="lockEvents">
    <LayoutFeatures />
    <LayoutContent  :class="[layoutClass]">
      <LayoutLeftMenu @changeLayout="changeLayout"/>
      <LayoutBody>
        <LayoutHeader />
        <LayoutCenter  style="height:calc(100% - 60px);overflow: auto;" />
        <LayoutFooter />
      </LayoutBody>
    </LayoutContent>
  </Layout>
</template>


<script lang="ts">
export default {
  name:'appFrame'
}
</script>
<script lang="ts" setup>
import Layout from './components/Layout.vue';
import LayoutContent from './components/LayoutContent.vue';
import LayoutLeftMenu from './components/LayoutLeftMenu.vue';
import LayoutBody from './components/LayoutBody.vue';
import LayoutHeader from './components/LayoutHeader.vue';
import LayoutCenter from '../../default/content/index.vue';
import LayoutFooter from './components/LayoutFooter.vue';

import {useDesign} from "@/hooks/web/useDesign";
import {useLockPage} from "@/hooks/web/useLockPage";
import {createAsyncComponent} from "@/utils/factory/createAsyncComponent";
import {computed, unref, ref, nextTick} from "vue";
//用户菜单样式信息
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";
import {useRouter} from "vue-router";
const {  getIsMixSidebar, getShowMenu } = useMenuSetting();
//样式前缀
const { prefixCls } = useDesign('default-layout');
//锁屏事件
const lockEvents = useLockPage();
//
const LayoutFeatures=createAsyncComponent(() => import('@/layouts/default/feature/index.vue'));
//动态样式
const layoutClass = computed(() => {
  let cls: string[] = ['ant-layout'];
  if (unref(getIsMixSidebar) || unref(getShowMenu)) {
    cls.push('ant-layout-has-sider');
  }
  return cls;
});

const router = useRouter();

const emit=defineEmits(["changeLayout"]);
const changeLayout=function ({item}){
  emit('changeLayout',{item});
}
</script>

<style type="text/css" lang="less"></style>
